import React, { useContext, useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import { FaRegCalendarAlt } from "react-icons/fa";
import AuthContext from "../../../context/auth-context";
import UpperbarContext from "../../../context/upperbar-context";
import Addition from "./Addition";
import Deduction from "./Deduction";
import ProvidentFund from "./ProvidentFund";
import Absent from "./Absent";
import All from "./All";

export default function PayrollReport() {
  const { User } = useContext(AuthContext);

  //   const searchInput = useRef("");
  const {
    fiscalYear,
    todayDate,
    mode,
    customStyles,
    appURL,
    userDetails,
    darkText,
  } = useContext(UpperbarContext);

  const [activeTab, setActiveTab] = useState({
    tab1: true,
    tab2: false,
    tab3: false,
    tab4: false,
    tab5: false,
  });

  const handleTab1 = () => {
    setActiveTab({
      tab1: true,
      tab2: false,
      tab3: false,
      tab4: false,
      tab5: false,
    });
  };
  const handleTab2 = () => {
    setActiveTab({
      tab1: false,
      tab2: true,
      tab3: false,
      tab4: false,
      tab5: false,
    });
  };
  const handleTab3 = () => {
    setActiveTab({
      tab1: false,
      tab2: false,
      tab3: true,
      tab4: false,
      tab5: false,
    });
  };
  const handleTab4 = () => {
    setActiveTab({
      tab1: false,
      tab2: false,
      tab3: false,
      tab4: true,
      tab5: false,
    });
  };
  const handleTab5 = () => {
    setActiveTab({
      tab1: false,
      tab2: false,
      tab3: false,
      tab4: false,
      tab5: true,
    });
  };

  return (
    <>
      {/* <Toast /> */}
      <div className="container-fluid classatten-wrapper ps-4 pe-4">
        <div className="row ">
          <div className="page-header">
            <div className="text-start  page-title" style={darkText}>
              {mode === "en" ? "Payroll Report" : "तलब रिपोर्ट"}
            </div>
            <div className="page-date">
              <div className="sec-content" style={darkText}>
                <FaRegCalendarAlt /> {todayDate} <span>|</span>{" "}
                {mode === "en" ? "Fiscal Year" : "वित्तीय वर्ष"} :{" "}
                {fiscalYear.StartDate}
                {fiscalYear.EndDate}
              </div>
            </div>
          </div>
          <hr className="title-hr" />
        </div>

        <>
          <div className="sec-dataTable">
            <div className="insidePopup mt-3">
              <ul>
                <li
                  className={activeTab.tab1 === true ? "active" : ""}
                  onClick={handleTab1}
                >
                  <i className="fa fa-sliders icon"></i>
                  {mode === "en" ? "Addition" : "थप"}
                </li>
                <li
                  className={activeTab.tab2 === true ? "active" : ""}
                  onClick={handleTab2}
                >
                  <i className="fas fa-sliders icon"></i>
                  {mode === "en" ? "Deduction" : "कटौती"}
                </li>
                <li
                  className={activeTab.tab3 === true ? "active" : ""}
                  onClick={handleTab3}
                >
                  <i className="fas fa-sliders icon"></i>
                  {mode === "en" ? "Provident Fund" : "सञ्चय कोष"}
                </li>
                <li
                  className={activeTab.tab4 === true ? "active" : ""}
                  onClick={handleTab4}
                >
                  <i className="fas fa-sliders icon"></i>
                  {mode === "en" ? "Absent" : "अनुपस्थित"}
                </li>
                <li
                  className={activeTab.tab5 === true ? "active" : ""}
                  onClick={handleTab5}
                >
                  <i className="fas fa-sliders icon"></i>
                  {mode === "en" ? "All" : "सबै"}
                </li>
              </ul>
            </div>
            <div>
              {activeTab.tab1 && <Addition />}
              {activeTab.tab2 && <Deduction />}
              {activeTab.tab3 && <ProvidentFund />}
              {activeTab.tab4 && <Absent />}
              {activeTab.tab5 && <All />}
            </div>
          </div>
        </>
      </div>
    </>
  );
}
